/**
* In this used to crop the users Profile images with popup design
**/
import { useRef } from "react";
import { Modal,Button } from 'react-bootstrap';
import Cropper from "react-cropper";
import 'cropperjs/dist/cropper.css';
import { useTranslation } from 'react-i18next';

function ImageCroper(props) {
	
	//Intial state declaration
	const cropperRef = useRef(null);
	const { t } = useTranslation();
	
	/**
	* To Handel the image crop function
	* @e we get the event details from the click action
	**/
	const handleCrop=async(e)=>{
		e.preventDefault();
		if (cropperRef.current) {
			const cropper = cropperRef.current.cropper;
			props.cropImge(cropper.getCroppedCanvas().toDataURL('image/png', 0.9));
		}
		props.handleClose();
	}
	
  return (
  <Modal 
	show={props.show} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton>
        <Modal.Title>{t('modal.editProfilePicture')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  {/*ImageCroper From*/}
	  <form  encType="multipart/form-data">	
	  {/*Impoer Cropper Module*/}
		<Cropper
		  ref={cropperRef}
          src={props.image}
          style={{ height: 400, width: '100%' }}
		  aspectRatio={NaN}
		  viewMode={2}
		  responsive={true}
		  autoCrop={true}
		  autoCropArea={1}
        />
	 </form>
	 {/*End ImageCroper From*/}
	  </Modal.Body>
	  {/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" onClick={props.handleClose}>
          {t('modal.close')}
        </Button>
        <Button variant="primary" onClick={handleCrop}>
          {t('modal.update')}
        </Button>
	  </Modal.Footer>
	  {/*End Footer*/}
	</Modal>
  );
}

export default ImageCroper;
